var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg20LogOut(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20-log-out"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.63907 11.3896C2.32083 11.7343 2.32083 12.2657 2.63907 12.6105L6.23907 16.5105C6.57621 16.8757 7.14561 16.8985 7.51084 16.5613C7.87608 16.2242 7.89886 15.6548 7.56172 15.2896L5.35598 12.9L13.5004 12.9C13.9974 12.9 14.4004 12.4971 14.4004 12C14.4004 11.503 13.9974 11.1 13.5004 11.1L5.35598 11.1L7.56171 8.71046C7.89886 8.34523 7.87608 7.77583 7.51084 7.43869C7.1456 7.10155 6.57621 7.12432 6.23907 7.48956L2.63907 11.3896ZM12.0004 2.10001C12.0004 2.59707 12.4033 3.00001 12.9004 3.00001L18.3004 3.00001C19.1288 3.00001 19.8004 3.67158 19.8004 4.50001L19.8004 19.5C19.8004 20.3284 19.1288 21 18.3004 21L12.9004 21C12.4033 21 12.0004 21.403 12.0004 21.9C12.0004 22.3971 12.4033 22.8 12.9004 22.8L18.3004 22.8C20.1229 22.8 21.6004 21.3226 21.6004 19.5L21.6004 4.50001C21.6004 2.67747 20.1229 1.20001 18.3004 1.20001L12.9004 1.20001C12.4033 1.20001 12.0004 1.60295 12.0004 2.10001Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20LogOut);
export default __webpack_public_path__ + "static/media/20-log-out.5ade90357eb454801c189759ee347a77.svg";
export { ForwardRef as ReactComponent };